import { render, staticRenderFns } from "./AddGroupMemberDialog.vue?vue&type=template&id=2ae869ba&scoped=true&"
import script from "./AddGroupMemberDialog.vue?vue&type=script&lang=js&"
export * from "./AddGroupMemberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae869ba",
  null
  
)

export default component.exports